class ChildPicker extends HTMLElement {
  constructor() {
    super();
    this.productInfo = this.closest("product-info");
    this.productSku = this.productInfo.querySelector(".product__sku");
    this.productImage = document.querySelector(".product__media img");
    this.regularPrices = this.productInfo.querySelectorAll(
      ".price-item--regular"
    );
    this.salePrices = this.productInfo.querySelectorAll(".price-item--sale");
    this.productTitle = this.productInfo.querySelector(".product__title h1");
    this.placeholder = this.productInfo.querySelector("summary span");
    this.toggleButton = this.querySelector("button");
    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", this.toggleHeight.bind(this));
    }
    this.options = document.querySelectorAll("child-picker li");
    this.options.forEach((option) => {
      option.addEventListener(
        "click",
        this.handleOptionClick.bind(this, option)
      );
    });
  }

  toggleHeight() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
    } else {
      this.setAttribute("open", "true");
    }
  }

  reset() {
    this.options.forEach((option) => {
      option.removeAttribute("aria-selected");
    });
  }

  selectVariant(variantId) {
    document
      .querySelectorAll(`li[data-variant-id="${variantId}"]`)
      .forEach((option) => {
        option.setAttribute("aria-selected", "true");
      });
    this.mapVariantInfo(variantId);
  }

  mapVariantInfo(variantId) {
    const option = this.querySelector(`li[data-variant-id="${variantId}"]`);
    if (this.productInfo.currentVariant) {
      this.productInfo.currentVariant.value = option.dataset.variantId;
    }
    this.salePrices.forEach((price) => {
      price.innerHTML = `£${Number(option.dataset.productPrice).toFixed(2)}`;
    });
    this.regularPrices.forEach((price) => {
      price.innerHTML = `£${Number(
        option.dataset.productCompareAtPrice
      ).toFixed(2)}`;
    });
    this.productImage.setAttribute("src", option.dataset.productImage);
    this.productImage.removeAttribute("srcset");
    this.productSku.innerHTML = `<span>Code: </span> ${option.dataset.productSku}`;
    this.productTitle.innerHTML = `${option.dataset.productTitle}`;
    this.placeholder.innerHTML = `${option.dataset.productTitle}`;
    if (
      Number(option.dataset.productPrice) <
      Number(option.dataset.productCompareAtPrice)
    ) {
      this.productInfo.querySelector(".price").classList.add("price--on-sale");
    } else {
      this.productInfo
        .querySelector(".price")
        ?.classList?.remove("price--on-sale");
    }
  }

  selectOnChildSlider(variantId) {
    const childSlider = document.querySelector("child-slider");
    if (childSlider) {
      childSlider.selectVariant(variantId);
    }
  }

  handleOptionClick(option) {
    this.reset();
    this.selectVariant(option.dataset.variantId);
    this.selectOnChildSlider(option.dataset.variantId);
  }
}
customElements.define("child-picker", ChildPicker);

class ChildSlider extends Carousel {
  constructor() {
    super();
    this.slides.forEach((slide) => {
      slide.addEventListener("click", this.handleSlideClick.bind(this, slide));
    });
    this.childPickers = document.querySelectorAll("child-picker");
  }
  handleSlideClick(slide) {
    if (slide instanceof HTMLLIElement) {
      this.childPickers.forEach((childPicker) => {
        if (childPicker instanceof ChildPicker) {
          childPicker.reset();
          childPicker.mapVariantInfo(slide.dataset.variantId);
        }
      });
      this.selectVariant(slide.dataset.variantId);
    }
  }
  reset() {
    this.slides.forEach((slide) => {
      slide.removeAttribute("aria-selected");
    });
  }
  selectVariant(variantId) {
    this.reset();
    document
      .querySelectorAll(`li[data-variant-id="${variantId}"]`)
      .forEach((option) => {
        option.setAttribute("aria-selected", "true");
      });
    const slide = this.querySelector(`li[data-variant-id="${variantId}"]`);
    // if (slide.scrollIntoViewIfNeeded) {
    //   slide.scrollIntoViewIfNeeded({ behavior: 'smooth' });
    // }
  }
}

customElements.define("child-slider", ChildSlider);
